import React from "react";
import { Route, Switch } from "react-router-dom";
import RestrictedRoute from "../containers/RestrictedRoute/RestrictedRoute";

import Homepage from "../modules/homepage/Homepage";
import HowItWorks from "../modules/homepage/HowItWorks";

// Auth module
import LogIn from "../modules/auth/LogIn";
import PasswordReset from "../modules/auth/PasswordReset";
import PasswordRecovery from "../modules/auth/PasswordRecovery";

// Register module

import Register from "../modules/register/Register";
import WhatIs from "../modules/register/pages/WhatIs";

// Account
import Account from "../modules/account/Account";
import AccountHome from "../modules/account/components/AccountHome";
import AccountProfile from "../modules/account/AccountProfile";
import AccountMedicalInformation from "../modules/account/AccountMedicalInformation";

// Test related pages
import TestItemDetail from "../modules/test/TestItemDetail";
import TestJoin from "../modules/test/TestJoin";
import OngoingTestDetail from "../modules/test/OngoingTestDetail";
import ReportTest from "../modules/test/ReportTest";

// Static pages
import ConsumerConsent from "../modules/shared/pages/ConsumerConsent";
import CookiePolicy from "../modules/shared/pages/CookiePolicy";
import PrivacyPolicy from "../modules/shared/pages/PrivacyPolicy";
import Terms from "../modules/shared/pages/Terms";
import VolunteerConsent from "../modules/shared/pages/VolunteerConsent";

import withTracker from "./withTracker";

const Router = () => (
  <Switch>
    <Route path="/auth" component={withTracker(AuthRouter)} />
    <Route path="/register" component={withTracker(RegisterRouter)} />
    <RestrictedRoute
      path="/account"
      type="private"
      component={withTracker(AccountRouter)}
    />
    <RestrictedRoute
      path="/test"
      type="private"
      component={withTracker(TestRouter)}
    />
    <Route path="/how-it-works" component={withTracker(HowItWorks)} />
    <Route
      path="/consentimiento-consumidores"
      component={withTracker(ConsumerConsent)}
    />
    <Route path="/politica-cookies" component={withTracker(CookiePolicy)} />
    <Route path="/politica-privacitad" component={withTracker(PrivacyPolicy)} />
    <Route path="/aviso-legal" component={withTracker(Terms)} />
    <Route
      path="/consentimiento-voluntarios"
      component={withTracker(VolunteerConsent)}
    />
    <Route path="/acm" component={withTracker(AccountMedicalInformation)} />
    <Route path="/" component={LogIn} />
  </Switch>
);

const AuthRouter = () => (
  <Switch>
    <Route path="/auth/login" component={LogIn} />
    <Route path="/auth/password-reset" component={PasswordReset} />
    <Route
      path="/auth/password-recovery/:token/:uid"
      component={PasswordRecovery}
    />
  </Switch>
);

const RegisterRouter = () => (
  <Switch>
    <Route exact path="/register/what-is" component={WhatIs} />
    <Route path="/register" component={Register} />
  </Switch>
);

const AccountRouter = () => (
  <Account>
    <Switch>
      <Route path="/account/home" component={AccountHome} />
      <Route path="/account/profile" component={AccountProfile} />
      <Route
        path="/account/medical-information"
        component={AccountMedicalInformation}
      />
    </Switch>
  </Account>
);

const TestRouter = () => (
  <Account>
    <Switch>
      <Route path="/test/:id/detail" component={TestItemDetail} />
      <Route path="/test/:id/join" component={TestJoin} />
      <Route path="/test/:id/ongoing" component={OngoingTestDetail} />
      <Route path="/test/:id/report/project/:project" component={ReportTest} />
    </Switch>
  </Account>
);

export default Router;



// WEBPACK FOOTER //
// ./src/app/Router.js